import { useState, useEffect } from 'react';
import { Target, Star, Trophy } from 'lucide-react';
import api from '../services/api';
import { Card } from './ui';

interface Analytics {
  slaAttainment: number | null;
  totalResolved: number;
  csatAverage: number | null;
  csatResponses: number;
  leaderboard: { agent: string; resolved: number }[];
}

export default function AnalyticsCards() {
  const [data, setData] = useState<Analytics | null>(null);

  useEffect(() => {
    api.get('/reports/analytics').then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div className="grid gap-3 md:grid-cols-3">
      <Card>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-brand/10 text-brand flex items-center justify-center"><Target size={20} /></div>
          <div>
            <div className="text-2xl font-bold text-navy leading-none">{data.slaAttainment != null ? `${data.slaAttainment}%` : '—'}</div>
            <div className="text-xs text-gray-500 mt-1">SLA attainment ({data.totalResolved} resolved)</div>
          </div>
        </div>
      </Card>
      <Card>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-amber-100 text-amber-600 flex items-center justify-center"><Star size={20} /></div>
          <div>
            <div className="text-2xl font-bold text-navy leading-none">{data.csatAverage != null ? `${data.csatAverage}/5` : '—'}</div>
            <div className="text-xs text-gray-500 mt-1">CSAT average ({data.csatResponses} ratings)</div>
          </div>
        </div>
      </Card>
      <Card title={<span className="flex items-center gap-1.5"><Trophy size={15} /> Top agents</span>}>
        {data.leaderboard.length === 0 ? (
          <p className="text-xs text-gray-400">No resolved tickets yet.</p>
        ) : (
          <ol className="space-y-1">
            {data.leaderboard.slice(0, 5).map((a, i) => (
              <li key={a.agent} className="flex items-center justify-between text-sm">
                <span className="text-navy"><span className="text-gray-400 mr-1.5">{i + 1}.</span>{a.agent}</span>
                <span className="font-semibold text-brand-dark">{a.resolved}</span>
              </li>
            ))}
          </ol>
        )}
      </Card>
    </div>
  );
}
